import {Box, Button, Menu} from '@viptech/react-components'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import actionsObject from 'src/images/actionsObject.svg'
import Config from 'src/images/config.svg'
import DownloadIconBlack from 'src/images/downloadIconBlack.svg'
import {Alarm} from '../../../../services/api'

type Props = {
  event: Alarm
}

function MenuOptions({event}: Props) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const navigate = useNavigate()

  const handleDownloadImages = () => {
    event.snapshots?.forEach((image) => window.open(`${process.env.REACT_APP_EVENT_IMAGES_BASE_URL}/${image.awsKey}`, '_blank', 'noopener,noreferrer'))
    setAnchor(null)
  }

  return (
    <>
      <Button variant='contained' color='transparent' onClick={(e) => setAnchor(e.currentTarget)} hoverColor='none'>
        <img src={actionsObject} alt='Menu logo' style={{width: 20, height: 20}} />
      </Button>
      <Menu anchor={anchor} onClose={() => setAnchor(null)} hideTriangle borderRadius='8px'>
        <Box display='flex' direction='column' padding='5px' justify='flex-start'>
          <Button variant='contained' color='transparent' hoverColor='#F5F5F5' onClick={() => navigate(`/registers/devices/${event.cameraId}`)}>
            <Box display='flex' columnGap='8px' align='center' justify='center' fontSize='12px'>
              <img src={Config} alt='Menu logo' style={{width: 15, height: 16}} />
              <span style={{color: '#364152'}}>Ir para configuração da câmera</span>
            </Box>
          </Button>

          <Button variant='contained' color='transparent' hoverColor='#F5F5F5' onClick={() => handleDownloadImages()}>
            <Box display='flex' columnGap='8px' align='center' justify='flex-start' fontSize='12px' width='100%'>
              <img src={DownloadIconBlack} alt='Menu logo' style={{width: 15, height: 16}} />
              <span style={{color: '#364152'}}>Baixar imagens do evento</span>
            </Box>
          </Button>
        </Box>
      </Menu>
    </>
  )
}

export default MenuOptions
